
import { useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import FieldText from "./form/FieldText";

export default function AnswerOtherAction({ answer }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [reportMessage, setReportMessage] = useState('');
    const [resultMessage, setResultMessage] = useState('');


    const handleTextChange = (e) => {
        setReportMessage(e.target.value);
    }

    const handleReport = () => {
        setIsLoading(true);
        setErrorMessage("");
        setResultMessage("");
        api.reportAnswer({
            token: LoginHelper.getToken(),
            answer_id: answer.id,
            message: reportMessage,
        }).then((result) => {
            setIsLoading(false);
            setResultMessage("گزارش با موفقیت ثبت شد.");
        }).catch((err) => {
            setIsLoading(false);
            setErrorMessage("ثبت گزارش با مشکل مواجه شد.");
            if (err && err.data) {
                setErrorMessage(err.data.message);
            }
        });
    }

    return (
        <>
            <div className="bg-white rounded-[10px] p-[10px]">
                <div className="flex flex-row">
                    <div className="spacer p-[2px]"></div>
                    <div className="cursor-pointer text-[#cc0000] font-Vazir-800 text-[12px] rounded-[10px] px-[10px] py-[5px]" onClick={() => setIsOpen(!isOpen)}>
                        گزارش
                    </div>
                </div>
                {isOpen && (
                    <>
                        <div className="spacer p-[15px]"></div>
                        <div>
                            <div className="text-[#4B5155] font-Vazir-800 text-[14px]">
                                آیا از گزارش محتوا مطمئن هستید؟
                            </div>
                            <div className="spacer p-[5px]"></div>
                            <div>
                                <FieldText
                                    className="font-Vazir-800"
                                    text={reportMessage}
                                    onChange={handleTextChange}
                                />
                            </div>
                            <div className="spacer p-[5px]"></div>
                            <div className="flex flex-row items-center">
                                <div className="cursor-pointer text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px]"
                                    onClick={() => setIsOpen(!isOpen)}>
                                    خیر
                                </div>
                                <div className="spacer p-[2px]"></div>
                                <div className="min-w-[50px] h-[30px]">
                                    <Button
                                        onClick={() => { handleReport() }}
                                        label={"بله"}
                                        isLoading={isLoading}
                                        color="#CC0000"
                                        textColor="#ffffff"
                                    />
                                </div>
                                <div className="spacer p-[2px]"></div>
                                <div className="text-[#008000]">
                                    {resultMessage}
                                </div>
                                <div className="text-[#cc0000]">
                                    {errorMessage}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    )
}
